import { create } from 'zustand';

export const usePreviewModeStore = create<{
  previewMode: boolean;
  setPreviewMode: (previewMode: boolean) => void;
}>((set) => ({
  previewMode: false,
  setPreviewMode: (previewMode: boolean) => set(() => ({ previewMode })),
}));
